<template>
    <div class="m-summary a-mobile">
        <div class="l-row">
            <div class="l-row__column">
                <div>
                    <p class="m-summary__label a-label a-label--big">Pierwszy dzień świadczenia usługi</p>
                    <p>{{ startDate }}</p>
                    <br />
                    <template v-if="endDate">
                        <p class="m-summary__label a-label a-label--big">
                            Ostatni dzień świadczenia usługi
                        </p>
                        <p>{{ endDate }}</p>
                    </template>
                </div>
            </div>
            <div class="l-row__column">
                <template
                    v-if="customerAddresses[0] && customerAddresses[0].street && customerAddresses[0].city"
                >
                    <p class="m-summary__label a-label a-label--big">Podsumowanie zamówienia</p>
                    <p class="a-title a-title--subtitle m-summary__deliveryTitle">Dostawy będą realizowane na adresy:</p>
                    <p
                        v-for="(address, idx) in customerAddresses"
                        v-bind:key="idx"
                        class="m-summary__deliveryAddress"
                    >
                        {{ address.street }} {{ address.number }}, {{ address.postcode }} {{ address.city }}
                    </p>
                </template>
            </div>
            <div class="l-row__column m-summary__summary">
                <p class="m-summary__title">Łączny koszt dostaw netto:</p>
                <p class="a-price"><span class="a-price__price">{{ totalAmount }}</span> <span class="a-price__time">/ 7 dni</span></p>
                <p class="a-price">{{ totalAmountMonth }} <span class="a-price__time">/ 1 mc</span></p>
                <o-notifications :is-static="true" />
                <div class="m-summary__buttons a-mobile__buttons">
                    <button
                        class="m-summary__button a-button a-button--secondaryInvert"
                        @click="rejectOfferModal"
                    >
                        Odrzuć ofertę
                    </button>
                    <button
                        class="m-summary__button a-button a-button--primary"
                        @click="handleSubmit"
                    >
                        Przejdź dalej
                        <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                </div>
            </div>
        </div>
        <o-modal name="rejectOffer">
            <template slot="content">
                <p class="a-text a-text--big a-text--center">
                    Podaj powód odrzucenia oferty:
                    <br /><br />
                    <a-control
                        placeholder="Powód odrzucenia oferty"
                        :id="`control-offer-reject`"
                        type="textarea"
                        rows="4"
                        v-model="rejectReason"
                    />
                </p>
                <br />
                <div class="a-mobile__buttons">
                    <a-button
                        class="a-button a-mobile__button"
                        @click="$store.dispatch('modalHide')"
                    >Powrót do oferty</a-button>
                    &nbsp;
                    <a-button
                        class="a-button a-button--secondary a-mobile__button"
                        @click="rejectOffer"
                    >Odrzuć ofertę</a-button>
                </div>
            </template>
        </o-modal>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            rejectReason: ''
        }
    },
    computed: {
        startDate() {
            return moment(this.$store.getters.customerAddressField(this.currentAddressId, 'dateFrom')).format('DD.MM.YYYY')
        },
        endDate() {
            const date = this.$store.getters.customerAddressField(this.currentAddressId, 'dateTo')
            if(date) {
                return moment(date).format('DD.MM.YYYY')
            } else {
                return false
            }
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        totalAmount() {
            return this.$store.getters.offerTotalAmount.toFixed(2).toPLN()
        },
        totalAmountMonth() {
            return this.$store.getters.offerTotalAmountMonth.toFixed(2).toPLN()
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        minimumValue() {
            return this.$store.getters.minimumValue
        },
        minimumDate() {
            return this.$store.getters.minimumDate
        },
        maximumDate() {
            return this.$store.getters.maximumDate
        },
        offDays() {
            return this.$store.getters.offDays
        },
        offerSlug() {
            return this.$store.getters.offerSlug
        },
        localeData() {
            return {
                firstDay: 1,
                format: 'DD-MM-YYYY',
                daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
            }
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },
        dateFormat(classes, date) {
            classes.disabled = moment(date).isBefore(this.minimumDate) || this.offDays.includes(moment(date).format('YYYY-MM-DD')) || moment(date).isAfter(this.maximumDate)
            return classes
        },
        handleSubmit() {
            if(this.customerAddresses[this.currentAddressId].clientDetailId !== null) {
                this.$router.push({ name: 'offer-checkout', params: { slug: this.offerSlug } })
            } else {
                this.$router.push({ name: 'offer-delivery-address', params: { slug: this.offerSlug } })
            }
        },
        rejectOfferModal() {
            this.$store.dispatch('modalHide')
            this.$store.dispatch('modalShow', {
                name: 'rejectOffer'
            })
        },
        rejectOffer() {
            this.$store.dispatch('rejectOffer', {
                slug: this.offerSlug,
                reason: this.rejectReason
            }).then(() => {
                this.$store.dispatch('modalHide')
                this.$router.push({ name: 'offer-thank-you-reject' })
            })
        }
    },
    created() {
        this.$store.dispatch('fetchOffDays')
    }
}
</script>
